import { gql } from '@apollo/client';

export const UPDATE_COST_CENTER = gql`
    mutation UpdateCostCenter($data: CostCenterUpdateInput!) {
        updateCostCenter(data: $data) {
            name
        }
    }
`;
